// Mirrors the Prisma enum in groupFtpFolder.prisma.
export const FTP_SUBFOLDER_ROLES = ['TO_CONCIERGE', 'AUTOMATION', 'RETURN', 'OPT_OUTS'] as const;

export type FtpSubfolderRole = (typeof FTP_SUBFOLDER_ROLES)[number];

export const FTP_SUBFOLDER_ROLE_LABELS: Record<FtpSubfolderRole, string> = {
  TO_CONCIERGE: 'Onboarding docs',
  AUTOMATION: 'Payroll and census',
  RETURN: 'Returned by CBS',
  OPT_OUTS: 'Opt-outs',
};

// How a file was opened from the FTP, for the access log.
export const FTP_FILE_ACTIONS = ['VIEWED', 'OPENED', 'DOWNLOADED', 'PREVIEWED'] as const;

export type FtpFileAction = (typeof FTP_FILE_ACTIONS)[number];
